/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface IArgs {
  title?: string;
}

interface UiProtectionDisputePanelPanelSignature {
  Element: HTMLElement;

  Args: IArgs;

  Blocks: {
    default: [];
    actions: [];
  };
}

const UiProtectionDisputePanelPanelComponent =
  templateOnly<UiProtectionDisputePanelPanelSignature>();

export default UiProtectionDisputePanelPanelComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel::Panel': typeof UiProtectionDisputePanelPanelComponent;
    'ui/protection/dispute-panel/panel': typeof UiProtectionDisputePanelPanelComponent;
  }
}
